module.exports = __webpack_public_path__ + "img/tryk_og_glad_malesider_2.b685dce9.jpg";